var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.question.rootClass },
    [
      _vm._l(_vm.question.renderedRankingChoices, function (item, index) {
        return !_vm.question.selectToRankEnabled
          ? _c("survey-ranking-item", {
              key: item.value + "-" + index + "-item",
              class: _vm.question.getItemClass(item),
              attrs: {
                text: item.locText,
                index: index,
                indexText: _vm.getNumberByIndex(index),
                cssClasses: _vm.question.cssClasses,
                question: _vm.question,
                item: item,
              },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.question.selectToRankEnabled
        ? _c(
            "div",
            {
              class: _vm.question.getContainerClasses("from"),
              attrs: { "data-ranking": "from-container" },
            },
            [
              _vm._l(
                _vm.question.renderedUnRankingChoices,
                function (item, index) {
                  return _c("survey-ranking-item", {
                    key: item.value + "-" + index + "-item",
                    class: _vm.question.getItemClass(item),
                    attrs: {
                      text: item.locText,
                      index: index,
                      indexText: _vm.getNumberByIndex(index),
                      cssClasses: _vm.question.cssClasses,
                      question: _vm.question,
                      item: item,
                      unrankedItem: true,
                    },
                  })
                }
              ),
              _vm._v(" "),
              _vm.question.renderedUnRankingChoices.length === 0
                ? _c(
                    "div",
                    { class: _vm.question.cssClasses.containerPlaceholder },
                    [
                      _c("survey-string", {
                        attrs: {
                          locString:
                            _vm.question.locSelectToRankEmptyRankedAreaText,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.question.selectToRankEnabled
        ? _c("div", { class: _vm.question.cssClasses.containersDivider })
        : _vm._e(),
      _vm._v(" "),
      _vm.question.selectToRankEnabled
        ? _c(
            "div",
            {
              class: _vm.question.getContainerClasses("to"),
              attrs: { "data-ranking": "to-container" },
            },
            [
              _vm._l(
                _vm.question.renderedRankingChoices,
                function (item, index) {
                  return _c("survey-ranking-item", {
                    key: item.value + "-" + index + "-item",
                    class: _vm.question.getItemClass(item),
                    attrs: {
                      text: item.locText,
                      index: index,
                      indexText: _vm.getNumberByIndex(index),
                      cssClasses: _vm.question.cssClasses,
                      question: _vm.question,
                      item: item,
                    },
                  })
                }
              ),
              _vm._v(" "),
              _vm.question.renderedRankingChoices.length === 0
                ? _c(
                    "div",
                    { class: _vm.question.cssClasses.containerPlaceholder },
                    [
                      _c("survey-string", {
                        attrs: {
                          locString:
                            _vm.question.locSelectToRankEmptyUnrankedAreaText,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }